"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseListExtension = void 0;
const index_js_1 = require("../../../../../errors/index.js");
const index_js_2 = require("../../../../../schema/actions/parse/index.js");
const isArray_js_1 = require("../../../../../utils/validation/isArray.js");
const isInteger_js_1 = require("../../../../../utils/validation/isInteger.js");
const isObject_js_1 = require("../../../../../utils/validation/isObject.js");
const index_js_3 = require("../../symbols/index.js");
const attribute_js_1 = require("./attribute.js");
const reference_js_1 = require("./reference.js");
function* listElementParser(attribute, inputValue, { transform = true }) {
    if ((0, index_js_3.isRemoval)(inputValue)) {
        const parsedValue = inputValue;
        if (transform) {
            yield parsedValue;
        }
        else {
            return parsedValue;
        }
        const transformedValue = parsedValue;
        return transformedValue;
    }
    if (inputValue === undefined) {
        const parsedValue = undefined;
        if (transform) {
            yield parsedValue;
        }
        else {
            return parsedValue;
        }
        const transformedValue = undefined;
        return transformedValue;
    }
    return yield* new index_js_2.Parser(attribute.elements).start(inputValue, {
        mode: 'update',
        fill: false,
        transform,
        parseExtension: attribute_js_1.parseUpdateExtension
    });
}
const parseListExtension = (attribute, input, options) => {
    const { transform = true } = options;
    if ((0, index_js_3.isSetting)(input) && input[index_js_3.$SET] !== undefined) {
        return {
            isExtension: true,
            *extensionParser() {
                const parser = new index_js_2.Parser(attribute).start(input[index_js_3.$SET], { fill: false, transform });
                const parsedValue = { [index_js_3.$SET]: parser.next().value };
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = { [index_js_3.$SET]: parser.next().value };
                return transformedValue;
            }
        };
    }
    if ((0, isObject_js_1.isObject)(input) || (0, isArray_js_1.isArray)(input)) {
        if ((0, index_js_3.isAppending)(input) && input[index_js_3.$APPEND] !== undefined) {
            const appendedValue = input[index_js_3.$APPEND];
            if ((0, isArray_js_1.isArray)(appendedValue)) {
                return {
                    isExtension: true,
                    *extensionParser() {
                        const parsers = appendedValue.map(element => 
                        // Should be a simple list of valid elements (not extended)
                        new index_js_2.Parser(attribute.elements).start(element, { fill: false, transform }));
                        const parsedValue = { [index_js_3.$APPEND]: parsers.map(parser => parser.next().value) };
                        if (transform) {
                            yield parsedValue;
                        }
                        else {
                            return parsedValue;
                        }
                        const transformedValue = { [index_js_3.$APPEND]: parsers.map(parser => parser.next().value) };
                        return transformedValue;
                    }
                };
            }
            return {
                isExtension: true,
                *extensionParser() {
                    const parser = new index_js_2.Parser(attribute).start(appendedValue, {
                        fill: false,
                        transform,
                        parseExtension: reference_js_1.parseReferenceExtension
                    });
                    const parsedValue = { [index_js_3.$APPEND]: parser.next().value };
                    if (transform) {
                        yield parsedValue;
                    }
                    else {
                        return parsedValue;
                    }
                    const transformedValue = { [index_js_3.$APPEND]: parser.next().value };
                    return transformedValue;
                }
            };
        }
        if ((0, index_js_3.isPrepending)(input) && input[index_js_3.$PREPEND] !== undefined) {
            const prependedValue = input[index_js_3.$PREPEND];
            if ((0, isArray_js_1.isArray)(prependedValue)) {
                return {
                    isExtension: true,
                    *extensionParser() {
                        const parsers = prependedValue.map(element => new index_js_2.Parser(attribute.elements).start(element, { fill: false, transform }));
                        const parsedValue = { [index_js_3.$PREPEND]: parsers.map(parser => parser.next().value) };
                        if (transform) {
                            yield parsedValue;
                        }
                        else {
                            return parsedValue;
                        }
                        const transformedValue = { [index_js_3.$PREPEND]: parsers.map(parser => parser.next().value) };
                        return transformedValue;
                    }
                };
            }
            return {
                isExtension: true,
                *extensionParser() {
                    const parser = new index_js_2.Parser(attribute).start(prependedValue, {
                        fill: false,
                        transform,
                        parseExtension: reference_js_1.parseReferenceExtension
                    });
                    const parsedValue = { [index_js_3.$PREPEND]: parser.next().value };
                    if (transform) {
                        yield parsedValue;
                    }
                    else {
                        return parsedValue;
                    }
                    const transformedValue = { [index_js_3.$PREPEND]: parser.next().value };
                    return transformedValue;
                }
            };
        }
        return {
            isExtension: true,
            *extensionParser() {
                let maxUpdatedIndex = 0;
                const parsers = Object.fromEntries(Object.entries(input).map(([index, element]) => [
                    index,
                    listElementParser(attribute, element, options)
                ]));
                for (const inputKey of Object.keys(parsers)) {
                    const parsedInputKey = parseFloat(inputKey);
                    if (!(0, isInteger_js_1.isInteger)(parsedInputKey)) {
                        const { path } = attribute;
                        throw new index_js_1.DynamoDBToolboxError('parsing.invalidAttributeInput', {
                            message: `Index of array attribute ${path !== undefined ? `'${path}' ` : ''}is not a valid integer`,
                            path,
                            payload: {
                                received: inputKey
                            }
                        });
                    }
                    maxUpdatedIndex = Math.max(maxUpdatedIndex, parsedInputKey);
                }
                const parsedValue = Object.fromEntries(Object.entries(parsers)
                    .map(([index, parser]) => [index, parser.next().value])
                    .filter(([, element]) => element !== undefined));
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = [...Array(maxUpdatedIndex + 1).keys()].map(index => {
                    const parser = parsers[index];
                    return parser === undefined ? undefined : parser.next().value;
                });
                return transformedValue;
            }
        };
    }
    return {
        isExtension: false,
        basicInput: input
    };
};
exports.parseListExtension = parseListExtension;
